import { post } from "@/utils/utils";

const crmManagement = {
  state: {},
  mutations: {
    QUERY_FOLLOWUP_RECORD_LIST(state, data) {
      state.followupRecordList = data.result;
    },
    QUERY_ALL_FOLLOWUP_RECORD_LIST(state, data) {
      state.allFollowupRecordList = data.result;
    }
  },
  actions: {
    queryFollowupRecordList({ commit }, params) {
      return post({
        commit,
        url: `/middle/storeGuiderFollowupRecord/queryFollowupRecordList`,
        name: "QUERY_FOLLOWUP_RECORD_LIST",
        params
      });
    },
    queryAllFollowupRecordList({ commit }, params) {
      return post({
        commit,
        url: `/middle/storeGuiderFollowupRecord/queryFollowupRecordList`,
        name: "QUERY_ALL_FOLLOWUP_RECORD_LIST",
        params
      });
    }
  }
};

export default crmManagement;
